import { ArrayInput, SimpleFormIterator, TextInput, required, maxLength, useSimpleFormIteratorItem, useTranslate } from 'react-admin';
import { AddButton, DownButton, RemoveButton, UpButton } from '@/components/global/buttons/CustomSimpleFormButtons.jsx';
import { noCharactersFromList } from '@/components/global/validators/customValidators.jsx';
import PropTypes from 'prop-types';

const TagInput = ({ language = 'pl', ...props }) => {
    const translate = useTranslate();

    const { index } = useSimpleFormIteratorItem();
    return (
        <TextInput
            {...props}
            validate={[
                required(translate('common.validation.required')),
                noCharactersFromList('!@#$^*+\\”"\'`|<>,[]{}'),
                maxLength(50, translate('common.validation.maxLength', { count: 50 })),
            ]}
            placeholder={`${language === 'pl' ? translate('common.tagName') : translate('common.tagNameEn')} ${index + 1}`}
            InputLabelProps={{
                shrink: true,
            }}
            sx={{
                width: 'calc(100% - 156px)',
            }}
        />
    );
};

TagInput.propTypes = {
    source: PropTypes.string.isRequired,
    label: PropTypes.string,
    language: PropTypes.string,
};

const TagCategoryListManager = ({ source, label = '', ...props }) => {
    const translate = useTranslate();
    return (
        <ArrayInput
            source={source}
            label={label}
            {...props}
            sx={{
                marginTop: '3px',
                '& > .Mui-error': { display: 'none' },
            }}
        >
            <SimpleFormIterator
                inline
                disableClear
                disableRemove
                disableReordering
                className='tag-category-list-manager'
                addButton={<AddButton label={translate('common.addAnotherTag')} sx={{ fontWeight: '400' }} />}
            >
                <UpButton label={translate('common.up')} />
                <DownButton label={translate('common.down')} />
                <TextInput source='id' readOnly sx={{ display: 'none' }} />
                <TagInput source='name' label={translate('common.namePl')} language='pl' />
                <TextInput source='nameEn' readOnly sx={{ display: 'none' }} />
                <TagInput source='nameEn' label={translate('common.nameEn')} language='en' />
                <RemoveButton label={translate('common.remove')} />
            </SimpleFormIterator>
        </ArrayInput>
    );
};

export default TagCategoryListManager;
